import { Navigate } from "react-router-dom";

function Setting() {
    return <Navigate to="/admin/config?tab=general" replace />;
}

export default Setting;
